import { useLocation } from 'react-router-dom';

export const useDoesToolRequireLinkedTasks = (): boolean => {
  const { pathname } = useLocation();
  // Currently only Scene Enrichment requires tasks to be linked by objectToken
  return doesToolRequireLinkedTasks(pathname);
};

export const doesToolRequireLinkedTasks = (pathname: string): boolean => {
  return pathname.includes('/scene-enrichment');
};
